import styled from "styled-components";

import { pink } from "@enkor/design/colors";
import { APP_SIZE } from "@styles/variables";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  width: 100%;
  width: 100%;
  max-width: ${APP_SIZE.MAX_WIDTH}px;
  height: 100%;
  height: 100vh;

  background-image: url("/assets/landing_background_1.png");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
`;

export const Section1 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;

  padding: 32px;
`;
export const Section2 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 0 32px 32px 32px;
`;

export const TitleH5 = styled.h5`
  font-weight: 700;
  font-size: 20px;
  font-family: "Jamsil";
  line-height: 24px;
  text-align: center;
  white-space: pre-wrap;
`;

export const TitleH2 = styled.h6`
  font-weight: 700;
  font-size: 40px;
  font-family: "Jamsil";
  line-height: 48px;

  > strong {
    color: ${pink.main};
    font-weight: 800;
    font-size: 40px;
    font-family: "Jamsil";
  }
`;

export const Content = styled.p`
  margin-bottom: 20px;

  font-weight: 400;
  font-size: 14px;
  font-family: "Jamsil";
  line-height: 20px;
  text-align: center;
  white-space: pre-wrap;
`;

export const TitleH6 = styled.h6`
  font-weight: 700;
  font-size: 24px;
  font-family: "Jamsil";
  line-height: 30px;
  text-align: center;

  > strong {
    color: ${pink.main};
    font-family: "Jamsil";
  }
`;

export const Logo = styled.div`
  position: relative;

  width: 99px;
  height: 36px;
  margin-top: 14px;
  margin-bottom: 43px;
`;

export const ImageWrapper = styled.div`
  position: relative;

  width: 100%;
  max-width: ${APP_SIZE.MAX_WIDTH}px;
  height: auto;
  margin-bottom: 20px;
`;
